module.exports = __webpack_public_path__ + "img/arty4 (Grande).ed99b385.png";